import jwtDecode from 'jwt-decode';

import { IUser } from 'types';

export function getProfileByToken(token?: string) {
  if (!token) {
    return null;
  }

  const { profile, type, idInvestor }: {
    profile: Omit<IUser, 'type' | 'idInvestor'>,
    type: IUser['type'],
    idInvestor: IUser['idInvestor'],
  } = jwtDecode<any>(token);

   return { ...profile, type, idInvestor };
}